import { AccountView } from './mapAccount';

export type AccountsTab = 'companies' | 'projects';

export interface DeriveParams {
  tab: AccountsTab;
  search: string;
  showInactive: boolean;
  sortAsc: boolean;
}

export const deriveRows = (
  all: AccountView[],
  { tab, search, showInactive, sortAsc }: DeriveParams
): AccountView[] => {
  const wantType = tab === 'companies' ? 'company' : 'project';
  let r = all.filter((a) => a.type === wantType);
  r = r.filter((a) => showInactive || a.active);

  const s = search.trim().toLowerCase();
  if (s) {
    r = r.filter(
      (a) =>
        a.name.toLowerCase().includes(s) ||
        a.managerName.toLowerCase().includes(s) ||
        a.email.toLowerCase().includes(s)
    );
  }

  r = [...r].sort((a, b) => a.name.localeCompare(b.name));
  if (!sortAsc) r.reverse();
  return r;
};
